import { DataService } from './../../../../services/data.service';
import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';


@Component({
  selector: 'app-student-scholastic-card',
  templateUrl: './student-scholastic-card.component.html',
  styleUrls: ['./student-scholastic-card.component.scss']
})
export class StudentScholasticCardComponent implements OnChanges, OnDestroy {

  @Input() profileData: any;

  favOtherSubject;
  favOtherLeastSubject;
  enableOtherFavText = true;
  enableOtherLeastFavText = true;
  favSubjectList;
  leastFavSubjectList;
  favIdList = [];
  leastFavIdList = [];
  scholasticFormsTouched = false;

  constructor(
    private dataService: DataService,
  ) {
    this.favSubjectList = this.dataService.getEntity('Subject').item || [];
    this.leastFavSubjectList = JSON.parse(JSON.stringify(this.favSubjectList));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.profileData && changes.profileData.currentValue) {
      this.favIdList = this.profileData.favoriteSubjectClassIds ? this.profileData.favoriteSubjectClassIds.map(item => parseInt(item, 10)) : [];
      this.leastFavIdList = this.profileData.leastFavoriteClassIds ? this.profileData.leastFavoriteClassIds.map(item => parseInt(item, 10)) : [];
      this.favOtherSubject = this.profileData.otherFavoriteSubject;
      this.favOtherLeastSubject = this.profileData.otherLeastFavoriteSubject;
      this.enableOtherFavText = !this.favOtherSubject;
      this.enableOtherLeastFavText = !this.favOtherLeastSubject;
    }
  }

  getSubjectData() {
    return { favSub: this.favIdList, leastFav: this.leastFavIdList, otherFavSubject: this.favOtherSubject, otherLeastFavSubject: this.favOtherLeastSubject };
  }

  checkboxChange(subject, arr, flag) {
    this.scholasticFormsTouched = true;
    const index = arr.indexOf(subject.id);
    if (index > -1) {
      arr.splice(index, 1)
    } else {
      arr.push(subject.id);
    }

    if (subject.text === 'Other Electives' && index === -1 && flag === 'fav') {
      this.enableOtherFavText = false;
    } else if (subject.text === 'Other Electives' && index > -1 && flag === 'fav') {
      this.enableOtherFavText = true;
      this.favOtherSubject = '';
    } else if (subject.text === 'Other Electives' && index > -1 && flag === 'leastFav') {
      this.enableOtherLeastFavText = true;
      this.favOtherLeastSubject = '';
    } else if (subject.text === 'Other Electives' && index === -1 && flag === 'leastFav') {
      this.enableOtherLeastFavText = false;
    }
  }
  ngOnDestroy() {
    this.scholasticFormsTouched = false;
  }
}
